import React from 'react';

import { useI18n } from 'common/hooks';
import svgIcons from 'common/svgIcons';

import Button from '../../Button/Button.component';
import SvgIconUrl from '../../SvgIconUrl/SvgIconUrl.component';
import { DepositButtonComponentProps } from '../DepositButton.component';

const ApplePayButton: React.FC<React.PropsWithChildren<DepositButtonComponentProps>> = ({ onClick, disabled }) => {
  const { translate } = useI18n();

  return (
    <Button
      onClick={onClick}
      className='deposit-buttons__item deposit-buttons__item--apple'
      data-test='deposit-button-apple-pay'
      disabled={disabled}
      large
      stretch
      color='black'
    >
      <SvgIconUrl symbol={svgIcons.Apple()} />
      <span>{translate.toText('mobile:deposit:apple-pay')}</span>
    </Button>
  );
};

export default React.memo(ApplePayButton);
